module.exports = __webpack_public_path__ + "static/img/jigou-hainan-top.aba2310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-hainan-top.png
// module id = SEnH
// module chunks = 2